import {useContextStore} from '@/stores/context';
import {MSConstant} from '@/commons/wildcards';
import i18nEnum from '@/i18ns/vi/i18nEnum';
export default [
  {
    path: '/summary-begin-estimate',
    name: 'summaryBeginYearEstimate',
    component: () => {
      var context = useContextStore();
      console.log(context.Context.OrganizationPackCodeType);
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.PTC) {
        return import(
          /* webpackChunkName:'demo'*/ '@/views/summaryEstimate/summaryBeginYear/SummaryBeginYearEstimate.vue'
        );
      }
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep) {
        return import(
          /* webpackChunkName:'demo'*/ '@/views/summaryEstimate/summaryBeginYear/SummaryBeginYearEstimateCQSN.vue'
        );
      }
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.STC) {
        return import(
          /* webpackChunkName:'demo'*/ '@/views/summaryEstimate/summaryBeginYear/SummaryBeginYearEstimateSTC.vue'
        );
      }
    },
    meta: {
      organizationPackCodeType: [
        MSConstant.OrganizationPackCodeType.PTC,
        MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep,
        MSConstant.OrganizationPackCodeType.STC,
      ],
    },
  },
  //tổng hợp sau kiểm tra (chỉ có ở đV chủ quản sự nghiệp)
  {
    path: '/summary-three-year-estimate/:key?',
    name: 'summary-three-year-estimate',
    component: () => {
      var context = useContextStore();
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep) {
        return import(
          /* webpackChunkName:'di'*/ '@/views/summaryEstimate/summaryThreeYear/SummaryThreeYearEstimate.vue'
        );
      }
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.STC) {
        return import(/* webpackChunkName:'di'*/ '@/views/summaryEstimate/summaryThreeYearSTC/SummaryThreeYearEstimateIndexSTC.vue');
      }
      if(context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.PTC) {
        return import(/* webpackChunkName:'di'*/ '@/views/demo/Publishing.vue');
      }
    },
    meta: {
      organizationPackCodeType: [
        i18nEnum.OrganizationPackCodeType.PTC,
        i18nEnum.OrganizationPackCodeType.DVCQSN,
        i18nEnum.OrganizationPackCodeType.STC,
      ],
    },
  },
  //Tổng hợp dự toán đầu năm
  {
    path: '/summary-estimate-initial',
    name: 'summaryEstimateInitial',
    component: () => {
    var context = useContextStore();
    return import('@/views/summaryEstimate/summaryEstimateInitial/SummaryEstimateInitialCQSN.vue');
    },
    meta: {
      organizationPackCodeType: [
        MSConstant.OrganizationPackCodeType.PTC,
        MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep,
        MSConstant.OrganizationPackCodeType.STC,
      ],
    },
  },
];
